import recurso_tipo_model from '@/shared/models/recurso_tipo_model';

export default {
  Activo: true,
  Descripcion: null,
  RecursoTipo: { ...recurso_tipo_model },
};
